var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPeopleManagedByDeletedPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01C29F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.06 7-.403-.143a1.5 1.5 0 0 1-.046-.977 3.873 3.873 0 0 0 1.013-2.974A2.683 2.683 0 0 0 10 0c-.388 0-.771.089-1.118.262a.208.208 0 0 0-.084.302c.463.693.707 1.508.702 2.34a5.222 5.222 0 0 1-.768 3.02.208.208 0 0 0 .1.31c2.5.934 3.045 1.667 3.2 1.99a.208.208 0 0 0 .26.105A6.54 6.54 0 0 1 13.572 8a.208.208 0 0 0 .051-.397A34.93 34.93 0 0 0 12.06 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.006 8.97a.21.21 0 0 0 .06-.292c-.416-.632-1.351-1.009-3.174-1.68l-.405-.143a1.5 1.5 0 0 1-.045-.977 3.873 3.873 0 0 0 1.013-2.974A2.683 2.683 0 0 0 5.833 0a2.683 2.683 0 0 0-2.621 2.904c-.1 1.08.261 2.15.994 2.949.106.32.106.666 0 .987l-.43.158C2.103 7.614.894 8.058.516 8.814A6.285 6.285 0 0 0 0 11.25c0 .23.187.417.417.417h8.052a.21.21 0 0 0 .186-.114 6.692 6.692 0 0 1 2.35-2.584zM14.583 9.167A5.417 5.417 0 1 0 20 14.583a5.423 5.423 0 0 0-5.417-5.416zm2.917 6.25h-5.833a.833.833 0 0 1 0-1.667H17.5a.833.833 0 0 1 0 1.667z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPeopleManagedByDeletedPeople);
export default __webpack_public_path__ + "static/media/total-people-managed-by-deleted-people.153b08dec4ed749b6935b99e04f4a157.svg";
export { ForwardRef as ReactComponent };